import React from 'react';
import { Provider } from 'react-redux';
import 'react-native-gesture-handler';

import WithSocket from './containers/WithSocket';
import AuthAwareNavigation from './containers/AuthAwareNavigation';

import { configureStore } from './helpers/store';

const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <WithSocket />
      <AuthAwareNavigation />
    </Provider>
  );
};

export default App;
